export const heroTitles = [
  { key: "smartphone", text: "스마트폰 구매" },
  { key: "cell", text: "통신사 가입" },
  { key: "usim", text: "유심 구매" },
];

export const introSlides = [
  {
    key: "intro-1",
    image: "./intro-1.jpeg",
    persona: "최신 스마트폰 & 가성비 모두 챙겨야 하는 20대 대학생 A님",
    quote:
      "“민트급 자급제폰을 할인된 가격으로 구매하고, 추천해준 저렴한 유심 요금제 가입으로 기존의 2년 약정으로 구매했을 때 보다 훨씬 더 저렴하게 스마트폰을 구매했어요.”",
  },
  {
    key: "intro-2",
    image: "./intro-2.jpeg",
    persona: "부모님 스마트폰 바꿔드리고 싶은 사회 초년생 30대 직장인 B님",
    quote:
      '"부모님께서는 이동통신사를 직접 방문하거나 복잡한 절차를 따라야 하는 불편함 없이, 제가 대신 모든 과정을 처리해드리니 정말 편리하셨어요. 온라인에서 간단하게 구매하고, 개통까지 문제없이 진행되니까 시간도 절약되고 부모님도 최신 기능을 바로 경험하실 수 있었습니다."',
  },
  {
    key: "intro-3",
    image: "./intro-3.jpeg",
    persona: "자녀들 스마트폰 구매부터 가족 통신비에 민감한 40대 가장 C님",
    quote:
      "“제 아이의 첫 스마트폰을 구매하면서, 평소에 바쁜 일정 때문에 직접 여러 통신사를 방문하거나 복잡한 절차를 거치기 어려웠는데, 스마트폰 구매부터 저렴한 요금제 및 결합을 통한 추가 할인 등 모든 과정을 온라인에서 간편하게 한 번에 처리하여 시간과 저희 가족 통신비용을 크게 절약 할 수 있었습니다.”",
  },
];

export const dnbnStats = [
  { value: "300억 +", label: "누적 매출액" },
  { value: "1위", label: "박스폰 판매" },
  { value: "10명중 9명+", label: "고객 만족" },
];

export const historyEntries = [
  { year: "2022년", items: ["• 삼성전자판매 공식 입찰협력사 선정"] },
  {
    year: "2023년",
    items: [
      "• LG U+ 공식 입찰협력사 선정",
      "• KT m&s 공식 입찰협력사 선정",
    ],
  },
  {
    year: "2025년",
    items: [
      "• 미디어로그 공식 입찰협력사 선정",
      "• 민팃 공식 입찰협력사 선정",
    ],
  },
];

export const conceptPrinciples = [
  {
    title:
      "스마트폰 단말기 구매와 통신상품 가입을 분리해서 각각 저렴하게 구매하고 가입하는게 더 유리하다",
  },
  {
    title:
      "스마트폰 단말기는 믿을 수 있는 판매처에서 “박스폰”을 최대한 저렴하게 구매한다",
    note: "* 박스폰: 새롭게 출시된 최신 자급제폰 부터 할인폭이 큰 민트급 미개통 자급제폰",
  },
  {
    title:
      "통신상품은 유심과 인터넷/TV를 통합상품으로 동시에 약정하여 추가 할인 및 지원금을 최대한 확보하는것이 더욱 유리하다",
  },
];

export const whyCards = [
  {
    image: "./why-1.png",
    imagePosition: "bg-center",
    title: "중간 유통구조 생략",
    body: "제조사/이동통신사들의 공식 협력업체로서 직접 대량으로 단말기 매입하여 바로 소비자들께 판매합니다",
  },
  {
    image: "./why-2.png",
    imagePosition: "bg-bottom",
    title: "서로 다른 시장에서 직접 쌓은 전문성",
    body: "서로 완전히 다른 단말기 유통시장과 통신사 요금제 약정 시장에서 직접 발로 뛰며 구축한 인프라로 자급제 구매부터 요금제 개통까지 한번에 해결해드립니다",
  },
  {
    image: "./why-3.png",
    imagePosition: "bg-bottom",
    title: "지원금 가장 많은 요금제 추천",
    body: "사실상 큰 차이 없는 수천개의 요금제 중 현 시점 최대의 지원금을 드릴 수 있는 답을 동네방네가 찾아 드립니다",
  },
];

export const productTypes = [
  { icon: "./icon-phone.png", label: "최신 자급제폰" },
  { icon: "./icon-box.png", label: "박스폰" },
  { icon: "./icon-tablet.png", label: "태블릿" },
  { icon: "./icon-watch.png", label: "스마트 워치" },
  { icon: "./icon-usim.png", label: "유심 요금제" },
  { icon: "./icon-setupbox.png", label: "인터넷 / TV 요금제" },
  { icon: "./icon-plan.png", label: "이통사 약정 요금제" },
  { icon: "./icon-accs.png", label: "악세사리" },
];
